import { Component, Injector, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AppComponentBase } from '@shared/app-component-base';
import { CompanyDto, CompanyServiceProxy, PrintingServiceProxy, PrintPoint, UserDto, UserServiceProxy, WarehouseDto, WarehouseServiceProxy } from '@shared/service-proxies/service-proxies';
import { DefaultSettingService } from '@shared/services/default-setting.service';
import { forkJoin } from 'rxjs';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-default-settings-dialog',
  templateUrl: './default-settings-dialog.component.html',
  styleUrls: ['./default-settings-dialog.component.css']
})
export class DefaultSettingsDialogComponent extends AppComponentBase implements OnInit {

  defaultCompanyId = 0;
  defaultWarehouseId = 0;
  defaultPrintPointName = "";

  companies: CompanyDto[] = [];
  warehouses: WarehouseDto[] = [];
  printPoints: PrintPoint[] = [];
  user: UserDto;
  constructor(injector: Injector,
    private _dialogRef: MatDialogRef<DefaultSettingsDialogComponent>,
    private _companyService: CompanyServiceProxy,
    private _warehouseService: WarehouseServiceProxy,
    private _defaultSettingService: DefaultSettingService,
    private _printingService: PrintingServiceProxy,
    private _userService: UserServiceProxy) { super(injector); }

  ngOnInit(): void {
    this._userService.get(abp.session.userId).subscribe(result => {
      this.user = result;
    });
    this.defaultCompanyId = this._defaultSettingService.getCompanyId();
    this.defaultWarehouseId = this._defaultSettingService.getWarehouseId();
    this.defaultPrintPointName = this._defaultSettingService.getPrintPointName();
    let req1 = this._companyService.getCompanyList();
    let req2 = this._warehouseService.getWarehouseList(this.defaultCompanyId);
    let req3 = this._printingService.getPrintPointList(this.defaultWarehouseId, "");
    this.spinner.show();
    forkJoin([req1, req2, req3])
      .pipe(
        finalize(() => this.spinner.hide())
      )
      .subscribe(res => {
        this.companies = res[0];
        this.warehouses = res[1];
        this.printPoints = res[2];
      })
  }
  private loadCompanyList() {
    this.spinner.show();
    this._companyService.getCompanyList()
      .pipe(
        finalize(() => this.spinner.hide())
      )
      .subscribe((result) => {
        this.companies = result;
      });
  }
  private loadWarehouseList() {
    this.spinner.show();
    this._warehouseService.getWarehouseList(this.defaultCompanyId)
      .pipe(
        finalize(() => this.spinner.hide())
      )
      .subscribe(results => {
        this.warehouses = results;
      });
  }
  private loadPrintPointList() {
    this.spinner.show();
    this._printingService.getPrintPointList(this.defaultWarehouseId, "")
      .pipe(
        finalize(() => this.spinner.hide())
      )
      .subscribe(results => {
        this.printPoints = results;
      });
  }
  onSelectCompany() {
    this.defaultPrintPointName = "";
    this.printPoints = [];
    if (this.defaultCompanyId == -1) {
      this.defaultWarehouseId = -1;
      this.warehouses = [];
    }
    else {
      this.defaultWarehouseId = -1;
      this.loadWarehouseList();
    }
  }
  onSelectWarehouse() {
    if (this.defaultWarehouseId == -1) {
      this.defaultPrintPointName = "";
      this.printPoints = [];
    }
    else {
      this.defaultPrintPointName = "";
      this.loadPrintPointList();
    }
  }
  save(): void {
    if (this.defaultPrintPointName == null || this.defaultPrintPointName === undefined)
      this.defaultPrintPointName = "";
    this.defaultPrintPointName = this.defaultPrintPointName.trim();

    // Ön Kontroller
    if (this.defaultCompanyId == -1)
      this.toastr.error(this.l("SelectCompany"));
    else if (this.defaultWarehouseId == -1)
      this.toastr.error(this.l("SelectWarehouse"));
    else if (this.defaultPrintPointName == "") {
      this.toastr.error(this.l("NoPrintPointNameSelected"));
    }
    else {
      this._defaultSettingService.setCompanyId(this.defaultCompanyId);
      this._defaultSettingService.setWarehouseId(this.defaultWarehouseId);
      this._defaultSettingService.setPrintPointName(this.defaultPrintPointName);
      this.toastr.success(this.l('SavedSuccessfully'));
      this._defaultSettingService.companyChangedSubject.next(null);
      this.close(true);
    }
    window.location.reload();
  }
  close(result: any): void {
    this._dialogRef.close(result);
  }
}
